import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "@/utils/axiosInstance";
import { handleThunkError } from "@/utils/thunkErrorHandler";

export const deleteFile = createAsyncThunk(
  "files/deleteFile",
  async (fileId: number, thunkAPI) => {
    try {
      await axiosInstance.delete(`/files/${fileId}`);
      return fileId;
    } catch (error) {
      return handleThunkError(
        error,
        thunkAPI,
        "Não foi possível remover o arquivo",
      );
    }
  },
);
